import { useEffect, useState } from 'react';
import tzlookup from 'tz-lookup';
import './TimezoneUtility.css';
// @ts-ignore
import { ParseCoordinates } from './CountryUtility';

interface LocalClockCoordinates {
  coordinates: string;
}

export function LocalClock({ coordinates }: LocalClockCoordinates) {
  const [date, setDate] = useState<Date | null>(null);
  const [timezone, setTimezone] = useState<string>('UTC');

  useEffect(() => {
    const [lat, lon] = ParseCoordinates(coordinates);
    if (!isNaN(lat) && !isNaN(lon)) {
      const tz = tzlookup(lat, lon);
      setTimezone(tz);

      const updateTime = () => {
        const now = new Date();
        const localeString = now.toLocaleString('en-US', { timeZone: tz });
        setDate(new Date(localeString));
      };

      updateTime();
      const interval = setInterval(updateTime, 1000);
      return () => clearInterval(interval);
    }
    return () => clearInterval(1000);
  }, [coordinates]);

  if (!date) return null;

  const seconds = date.getSeconds();
  const minutes = date.getMinutes();
  const hours = date.getHours();

  const secondDeg = seconds * 6; // 360 / 60
  const minuteDeg = minutes * 6 + seconds * 0.1;
  const hourDeg = ((hours % 12) / 12) * 360 + minutes * 0.5;

  const digital = date.toLocaleTimeString('en-US', {
    hour: '2-digit',
    minute: '2-digit',
    second: '2-digit',
  });

  return (
    <div className="clock-container">
      <div className="analog-clock">
        <div className="clock-center" />
        <div className="hand hour-hand" style={{ transform: `translate(-50%, -100%) rotate(${hourDeg}deg)` }} />
        <div className="hand minute-hand" style={{ transform: `translate(-50%, -100%) rotate(${minuteDeg}deg)` }} />
        <div className="hand second-hand" style={{ transform: `translate(-50%, -100%) rotate(${secondDeg}deg)` }} />
        <div className="clock-markers">
          {Array.from({ length: 12 }).map((_, i) => (
            <div key={i} className="marker" style={{ transform: `rotate(${i * 30}deg)` }}>
              <span className="marker-line" style={{ transform: `rotate(${-i * 30}deg)` }} />
            </div>
          ))}
        </div>
        <div className="clock-numbers">
          <div className="num num12">12</div>
          <div className="num num3">3</div>
          <div className="num num6">6</div>
          <div className="num num9">9</div>
        </div>
      </div>

      <div className="digital-clock">
        <div className="digital-time">{digital}</div>
        <div className="digital-timezone">Timezone: {timezone}</div>
      </div>
    </div>
  );
}
